import React, {Component} from 'react'
import { PhoneInput } from 'react-international-phone'
import { validateEmail } from '../../utils/helpers'

class Contact extends Component {
  constructor(props) {
    super(props)
    this.state = {
      phone: '',
      nameError: null,
      emailError: null,
      topicError: null,
      msgError: null,
      fileError: null,
      file: null,
      country: Shopify.country == 'JP' ? 'Japanese' : (Shopify.country == 'KR' ? 'Korean' : 'English'),
    }
    this.formRef = React.createRef()
  }
  
  validateForm(e) {
    e.preventDefault()
    e.stopPropagation()

    const form = this.formRef.current
    let hasError = false
    const description = form.querySelector('[name="message[description]"]')
    if(description.value?.trim() == '') {
      hasError = true
      this.setState({ msgError: window.pageStrings.contact.errors.message })
      description.focus()
    }

    const topic = form.querySelector('[name="message[topic]"]')
    if(!topic.value) {
      hasError = true
      this.setState({ topicError: window.pageStrings.contact.errors.topic })
      topic.focus()
    }

    const email = form.querySelector('[name="message[email]"]')
    if(!validateEmail(email.value?.trim())) {
      hasError = true
      this.setState({ emailError: window.pageStrings.contact.errors.email })
      email.focus()
    }

    const firstName = form.querySelector('[name="message[first_name]"]')
    if(firstName.value?.trim() == '') {
      hasError = true
      this.setState({ nameError: window.pageStrings.contact.errors.firstName })
      firstName.focus()
    }

    if (!hasError) {
      grecaptcha.ready(() => {
        grecaptcha
          .execute('6LdhVgMsAAAAAGxzjy5ofgx1E9LEFmsIG9CBNVZm', { action: 'submit' })
          .then(token => {
            const hiddenInput = form.querySelector('#g-recaptcha-response')
            if (hiddenInput) {
              hiddenInput.value = token
            }
            form.submit()
          })
      })
    }
  }
  handleFile(e) {
    const selectedFile = e.target.files[0]
    if(selectedFile.size / 1024.0 / 1024.0 <= 20) {
      this.setState({
        file: selectedFile,
        fileError: null,
      })
    } else {
      this.setState({
        file: null,
        fileError: 'Max file size: 20MB',
      })
      this.formRef.current.querySelector('[name="attachment"]').value = ''
    }
  }

  render() {
    return (
      <form
        className='salesforce-contact-form grid grid-cols-1 gap-x-5 gap-y-9 text-xs'
        noValidate
        // action="https://thombrowneinc.my.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8"
        action={`https://${window.tbApiDomain}/messages`}
        method="POST"
        ref={this.formRef}
        encType='multipart/form-data'
      >
        <input type="hidden" name="orgid" value="00D8c000002dqqJ" />
        <input type="hidden" name="retURL" value={ `${window.shopUrl}${Shopify.country == 'JP' ? '/ja-jp' : ''}${Shopify.country == 'KR' ? '/ko-kr' : ''}/pages/contact?formsubmit=true` } />
        <input type="hidden" name="g-recaptcha-response" id="g-recaptcha-response" />
        <input type="hidden" name="message[return_url]" value={ `${window.shopUrl}${Shopify.country == 'JP' ? '/ja-jp' : ''}${Shopify.country == 'KR' ? '/ko-kr' : ''}/pages/contact?formsubmit=true` } />
        <input type="hidden" name="recordType" id="recordType" value="0128c000001SDti" />
        <input type="hidden" 
          id="00N8c00000hQBwi" 
          // name="00N8c00000hQBwi" 
          name='message[country]' 
          value={this.state.country} 
          />
        <input type="hidden"  
          name='message[language]' 
          value={`${Shopify.locale}_${Shopify.country}`} 
          />
        {
          location.search.includes('formsubmit=true') && <div className="">{window.pageStrings.contact.thankyou}</div>
        }
        {
          !location.search.includes('formsubmit=true') &&
          <>
            <div className="grid grid-cols-2 gap-5">
              <div className={`input-wrap ${this.state.nameError ? 'input-error' : ''}`}>
                <input type="text" 
                  // name="00N79000000k9jv"
                  name='message[first_name]' 
                  id="first-name" 
                  placeholder={window.pageStrings.contact.firstName}
                  onChange={e => this.setState({ nameError: null })}
                  required
                  onFocus={e => e.target.closest('.input-wrap').classList.add('input-wrap__filled')}
                  onBlur={e => {
                    e.target.closest('.input-wrap').classList.toggle('input-wrap__filled', !!e.target.value)
                  }}
                  aria-describedby={ this.state.nameError ? 'contactFormNameError' : null } 
                />
                <label htmlFor="first-name">{window.pageStrings.contact.firstName}</label>
                { this.state.nameError && 
                  <div id="contactFormNameError" className='text-[0.625rem] text-tb-red absolute right-0 -bottom-4'>{this.state.nameError}</div> 
                }
              </div>
              <div className="input-wrap">
                <input type="text" 
                  // name="00N79000000k9jM"
                  name='message[last_name]' 
                  id="last-name" 
                  placeholder={window.pageStrings.contact.lastName} 
                  onFocus={e => e.target.closest('.input-wrap').classList.add('input-wrap__filled')}
                  onBlur={e => {
                    e.target.closest('.input-wrap').classList.toggle('input-wrap__filled', !!e.target.value)
                  }} 
                />
                <label htmlFor="last-name">{window.pageStrings.contact.lastName}</label>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-5">
              <div className={`input-wrap ${this.state.emailError ? 'input-error' : ''}`}>
                <input type="email" 
                  name="message[email]" 
                  id="email" 
                  placeholder={window.pageStrings.contact.email} 
                  onChange={e => this.setState({ emailError: null })}
                  required
                  onFocus={e => e.target.closest('.input-wrap').classList.add('input-wrap__filled')}
                  onBlur={e => {
                    e.target.closest('.input-wrap').classList.toggle('input-wrap__filled', !!e.target.value)
                  }}
                  aria-describedby={ this.state.emailError ? 'contactFormEmailError' : null }  
                />
                <label htmlFor="email">{window.pageStrings.contact.email}</label>
                { this.state.emailError && 
                  <div id="contactFormEmailError" className='text-[0.625rem] text-tb-red absolute right-0 -bottom-4'>{ this.state.emailError }</div> 
                }
              </div>
              <div className="flex flex-col justify-end">
                <div className="input-wrap relative">
                  <label htmlhtmlFor="phone" className='!hidden'>{window.pageStrings.contact.phone}</label>
                  <PhoneInput
                    defaultCountry="us"
                    value={this.state.phone}
                    name="message[phone]"
                    id="phone"
                    onChange={(phone) => this.setState({phone})}
                  />
                </div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-5">
              <div className={`select-wrap ${this.state.topicError ? 'input-error' : ''}`}>
                <select id="topic" 
                  // name="type"
                  name='message[topic]'
                  onChange={e => this.setState({ topicError: null })} 
                  required
                  aria-describedby={ this.state.topicError ? 'contactFormTopicError' : null }
                >
                  <option value="" disabled="">{window.pageStrings.contact.topics.title}</option>
                  {
                    window.pageStrings.contact.topics.list.map((value, index) =>
                      <option key={`topic-${index}`} value={value}>{value}</option>
                    )
                  }
                </select>
                { this.state.topicError && 
                  <div id="contactFormTopicError" className='text-[0.625rem] text-tb-red absolute right-0 -bottom-4'>{ this.state.topicError }</div> 
                }
              </div>
              <div className="input-wrap">
                <input type="text" 
                  name="message[subject]" 
                  id="subject" 
                  placeholder={window.pageStrings.contact.subject} 
                  onFocus={e => e.target.closest('.input-wrap').classList.add('input-wrap__filled')}
                  onBlur={e => {
                    e.target.closest('.input-wrap').classList.toggle('input-wrap__filled', !!e.target.value)
                  }} 
                />
                <label htmlFor="subject">{window.pageStrings.contact.subject}</label>
              </div>
            </div>
            <div className="grid grid-cols-1">
              <div className={`input-wrap ${this.state.msgError ? 'input-error' : ''}`}>
                <textarea 
                  // name="description"
                  name='message[description]' 
                  id="description"
                  className='!normal-case' 
                  placeholder={window.pageStrings.contact.message}
                  onChange={e => this.setState({ msgError: null })} 
                  required
                  aria-describedby={ this.state.msgError ? 'contactFormMsgError' : null } 
                />
                <label htmlFor="description">{window.pageStrings.contact.message}</label>
                { this.state.msgError && 
                  <div id="contactFormMsgError" className='text-[0.625rem] text-tb-red absolute right-0 -bottom-4'>{ this.state.msgError }</div> 
                }
              </div>
            </div>
            <div>
              {this.state.file && 
                <div className='p-3.75 bg-ninth-grey flex items-center justify-between mb-3.75'>
                  <div className='flex items-center'>
                    <span className='w-4 h-4 mr-2.5' dangerouslySetInnerHTML={{ __html: window.globalIcons['icon-picture']}} />
                    {this.state.file.name}
                  </div>
                  <button dangerouslySetInnerHTML={{ __html: window.globalIcons['icon-close']}} 
                    onClick={e => {
                      e.preventDefault()
                      this.formRef.current.querySelector('[name="attachment"]').value = ''
                      this.setState({file: null})
                    }}
                    />
                </div>
              }
              
              <label className='contact-form--file border border-tb-black block cursor-pointer hover:bg-ninth-grey'>
                <input type="file" 
                  className='visually-hidden' 
                  name="message[file]" 
                  accept="image/png, image/jpeg, image/webp, application/pdf"
                  onInput={e => this.handleFile(e)}
                  aria-describedby={ this.state.fileError ? 'contactFormFileError' : null }
                />
                
                <div className='flex items-center justify-between p-3.75'>
                  {window.pageStrings.contact.attachAFile}
                  <span className='tb-fourth-grey normal-case'>
                    {window.pageStrings.contact.sizeLimit}
                  </span>
                </div>
              </label>
              
              {
                this.state.fileError && <div id="contactFormFileError" className='text-[0.625rem] text-tb-red text-right'>{this.state.fileError}</div>
              }
            </div>
            <div className="text-[0.625rem] contact-form-privacy" dangerouslySetInnerHTML={{ __html: window.pageStrings.contact.privacy}} />
            
            <input className="button button--primary !w-full"
              type="submit" 
              value={window.pageStrings.contact.sendMessage}
              onClick={e => this.validateForm(e)}
            />
          </>
        }
      </form>
    )
  }
}

export default Contact